module.exports = __webpack_public_path__ + "img/m_icon.952a83a2.png";